import Vue from 'vue'
import './services/firebase'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import router from './router'
import VueMdc from 'vue-mdc'
import 'vue-mdc/dist/vue-mdc.css'
import VueFire from 'vuefire'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import SequentialEntrance from 'vue-sequential-entrance'
import 'vue-sequential-entrance/vue-sequential-entrance.css'
import VueCodeMirror from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import VS2 from 'vue-script2'
import VueAnalytics from 'vue-ua'
import VueParticles from 'vue-particles'

library.add(faCheckCircle)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

Vue.use(BootstrapVue)

Vue.use(VueMdc)

Vue.use(VueFire)

Vue.use(SequentialEntrance)

Vue.use(VueCodeMirror)

Vue.use(require('vue-moment'))

Vue.use(VS2)

Vue.use(VueParticles)

Vue.use(VueAnalytics, {
  appName: 'Product Planet',
  appVersion: 'v1',
  trackingId: 'UA-132223663-1',
  router: router,

  globalDimensions: [
    { dimension: 1, value: 'First Dimension'}
  ],

  globalMetrics: [
    {metric: 1, value: 'MyMetric'}
  ]
});



Vue.directive('no-tab-focus', function(el) {
  const ul = el.querySelector('ul.nav[tabindex="0"]');
  if (typeof ul !== 'undefined') {
      ul.tabIndex = -1;
  }
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

